import { Tag } from 'antd';
import { UserProjectStatus } from '@teachur/http-client';

type UserProjectStatusTagProps = {
  status: UserProjectStatus;
};

const statusColors = {
  [UserProjectStatus.Approved]: 'green',
  [UserProjectStatus.NotYet]: 'red',
  [UserProjectStatus.InReview]: 'yellow',
  [UserProjectStatus.Pending]: 'orange',
};

const statusText = {
  [UserProjectStatus.Approved]: 'APPROVED',
  [UserProjectStatus.NotYet]: 'NOT YET',
  [UserProjectStatus.InReview]: 'IN REVIEW',
  [UserProjectStatus.Pending]: 'REVIEW PENDING',
};

export const UserProjectStatusTag: React.FC<UserProjectStatusTagProps> = ({ status }) => {
  return <Tag color={statusColors[status]}>{statusText[status]}</Tag>;
};
